import { render, staticRenderFns } from "./LineDialogDataTabComponent.vue?vue&type=template&id=2c7fdaff&scoped=true"
import script from "./LineDialogDataTabComponent.js?vue&type=script&lang=js&external"
export * from "./LineDialogDataTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./LineDialogDataTabComponent.vue?vue&type=style&index=0&id=2c7fdaff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7fdaff",
  null
  
)

export default component.exports